class FumCircleHighlight {
    constructor(
        selectorName = '',
        cssVariablePrefix = '',
        ignoreSX = false,
        disableAnimation = false,
        svgPath = null,
        attributes = {
            style: {
                color: 'color',
                thickness: 'thickness',
                transitionDuration: 'transition-duration',
                transitionTiming: 'transition-timing',
                opacity: 'opacity'
            },
            animate: 'animate'
        }
    ) {
        // Global Configuration
        this.globalConfig = {
            selectorName,
            cssVariablePrefix,
            els: document.querySelectorAll(selectorName),
            svg: {
                namespace: 'http://www.w3.org/2000/svg',
                transformVars: {
                    widthGain: 1,
                    heightGain: 1
                }
            },
            ignoreSX,
            disableAnimation,
            attributes,
            svgPath,
            withObserver: false
        }

        // Styles
        this.styles = {
            thickness: "2px",
            color: '#000',
            width: '100%',
            height: '100%'
        }

        return this;
    }

    sx(sxParams) {
        this.styles = sxParams;
        return this;
    }

    setPropertyVars() {
        this.globalConfig.els.forEach((element) => {
            Object.entries(this.globalConfig.attributes.style)
            .forEach(([key, value]) => {
                try {
                    const getAttributeValue = element.getAttribute(value);
                    element.style.setProperty(`${this.globalConfig.cssVariablePrefix}-style--${value ?? key}`, getAttributeValue);
                } catch (e) {}
            });
        })
    }

    renderCircleShape() {
        /* Observer */
        const observerCallback = (entries, observer) => {
            entries.forEach((entry, index) => {
                const element = entry.target;
                const _vars = {
                    // width: 0.85 * element.offsetWidth,
                    // height: 1.4 * element.offsetHeight,
                    width: element.offsetWidth,
                    height: element.offsetHeight,
                    el: {
                        animate: element.getAttribute(this.globalConfig.attributes.animate)?.toLowerCase() == "true" ? true : false
                    },
                    pathStyleVars: {
                        thickness: element.getAttribute(this.globalConfig.attributes.style.thickness) ?? this.styles?.thickness ?? "2px",
                        color: element.getAttribute(this.globalConfig.attributes.style.color) ?? this.styles?.color ?? "#000",
                        opacity: element.getAttribute(this.globalConfig.attributes.style.opacity) ?? this?.styles?.opacity ?? 1
                    },
                    transitionVars: {
                        duration: element.getAttribute(this.globalConfig.attributes.style.transitionDuration) ?? '2s',
                        timing: element.getAttribute(this.globalConfig.attributes.style.transitionTiming) ?? 'ease-in-out',
                    }
                }

                const delay = index + 100;
        
                // Create SVG element
                let _svg = document.createElementNS(this.globalConfig.svg.namespace, "svg");
    
                // Set styles
                _svg.style.width =  _vars.width;
                _svg.style.height =  _vars.height;
                    _svg.style.transform = `scale(1.2)`;

                // Set attributes
                _svg.setAttribute("width", this.styles?.width ?? _vars.width);
                _svg.setAttribute("height", this.styles?.height ?? _vars.height);
                _svg.setAttribute("viewBox", `0 0 ${_vars.width} 32`);
    
                // Append '_svg' as child on 'element'
                element.appendChild(_svg);
    
                // Create path element
                const _path = document.createElementNS(this.globalConfig.svg.namespace, "path");
                _path.setAttribute("vector-effect", "non-scaling-stroke");
                _path.setAttribute("stroke-width", _vars.pathStyleVars?.thickness);
                _path.setAttribute("stroke", _vars.pathStyleVars.color);
                _path.setAttribute("opacity", _vars.pathStyleVars.opacity);
                _path.style.transform = `scaleX(${2 * _vars.width / 250})`;
    
                // Append '_path' as child on '_svg'.
                _svg.appendChild(_path);
                
                const setVisibility = (state = false) => {
                    const _pathLength = 1000 * _path.getTotalLength();
                    _path.setAttribute("visibility", state ? "visible" : "hidden");
                    _path.setAttribute("d", this.globalConfig.svgPath ?? circlePath(-0.15, 0.05, 150, 190, 0.05, 0.3));
                    _path.setAttribute("stroke-dasharray", _pathLength);
    
                    // Apply the initial stroke-dashoffset
                    _path.setAttribute("stroke-dashoffset", _pathLength);
    
                    // Force a reflow to ensure the above settings are applied before animation
                    _path.getBoundingClientRect();
    
                    if (state) {
                        // Set visibility to visible and animate the stroke-dashoffset
                        _path.style.visibility = "visible";
                        // _path.style.transition = `stroke-dashoffset ${_vars.transitionVars.duration} ${_vars.transitionVars.timing}`;
                        _path.style.transition = `stroke-dashoffset 4s ${_vars.transitionVars.timing}`;
                        _path.setAttribute("stroke-dashoffset", 0);
                    } else {
                        _path.setAttribute("stroke-dashoffset", _pathLength);
                    }
                }

                // count length
                _path.setAttribute("pathLength", 100000);
    
                setVisibility(false);

                if (entry.isIntersecting) {
                    setTimeout(() => {
                        setVisibility(true);
                    }, delay);
                } else {
                    setVisibility(false);
                }
            });
        }

        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        }

        const observer = new IntersectionObserver(observerCallback, observerOptions);
        this.globalConfig.els.forEach((element) => {
            if (this.globalConfig.withObserver == true) {
                observer.observe(element);
            } else {
                
    
                setVisibility(false);
                
                setVisibility(true);
            }
           
        });
    }

    init(withObserver = true) {
        this.globalConfig.withObserver = withObserver;
        this.setPropertyVars();
        this.renderCircleShape();
    }
}

function circlePath(δr_min,δr_max, θ0_min, θ0_max, δθ_min,δθ_max) {
    var c = 0.551915024494,
        β = Math.atan(c),
        d = Math.sqrt(c*c+1*1),
        r = 1,
        θ = (θ0_min + Math.random()*(θ0_max - θ0_min))*Math.PI/180,
        path = 'M';
    
    path += [r * Math.sin(θ), r * Math.cos(θ)];
    path += ' C' + [d * r * Math.sin(θ + β), d * r * Math.cos(θ + β)];
    
    for (var i=0; i<4; i++) {
        θ += Math.PI/2 * (1 + δθ_min + Math.random()*(δθ_max - δθ_min));
        r *= (1 + δr_min + Math.random()*(δr_max - δr_min));
        path += ' ' + (i?'S':'') + [d * r * Math.sin(θ - β), d * r * Math.cos(θ - β)];
        path += ' ' + [r * Math.sin(θ), r * Math.cos(θ)];
    }
    
    return path;
}

function circlePathStatic() {
    var path = 'M103.2 11.37C99.95 9.38002 96.31 8.11002 92.87 7.04002C88.54 5.69002 83.88 4.56002 78.22 3.50002C72.76 2.47002 66.98 1.65002 61.05 1.05002C54.94 0.430021 48.93 0.0800212 43.16 0.0100212C36.99 -0.0599788 31.49 0.170021 26.36 0.720021C20.8 1.32002 16.4 2.21002 12.5 3.50002C9.62004 4.45002 5.97004 5.91002 3.25004 8.73002C1.02004 11.05 -0.189961 14.34 0.0200386 17.52C0.270039 21.14 2.54004 23.6 4.41004 25.02C7.66004 27.5 11.51 28.73 14.85 29.6C18.96 30.67 23.54 31.4 29.26 31.89C34 32.3 39.11 32.49 44.86 32.49C45.12 32.49 45.38 32.49 45.64 32.49C50.75 32.47 56.08 32.3 61.93 31.97C66.49 31.71 71.26 31.35 76.1 30.9C79.43 30.59 82.79 30.24 86.11 29.84C87.38 29.69 88.64 29.54 89.9 29.36C90.26 29.31 90.41 28.79 90.53 28.21C90.54 28.14 90.55 28.09 90.56 28.07L90.34 27.98L90.31 27.73C90.31 27.73 90.29 27.73 90.28 27.73L89.39 27.85C87.2 28.13 84.95 28.4 82.52 28.66C78.66 29.08 74.64 29.45 70.6 29.77C65.37 30.18 60.27 30.48 55.44 30.65C49.58 30.87 44.25 30.9 39.14 30.76C33.18 30.59 28.25 30.21 23.62 29.56C20.04 29.05 15.34 28.25 10.81 26.5C8.20004 25.49 4.92004 23.97 2.78004 21.12C1.13004 18.93 0.560039 15.83 1.31004 13.23L1.34004 13.13C1.36671 13.0434 1.40337 12.9367 1.45004 12.81C1.45004 12.81 1.53004 12.61 1.55004 12.55C1.62004 12.39 1.78004 12.08 1.91004 11.86C2.24004 11.31 2.64004 10.78 3.14004 10.25C4.10004 9.22002 5.31004 8.29002 6.84004 7.42002C10.65 5.25002 14.89 4.20002 18.16 3.53002C22.65 2.61002 27.5 2.05002 33.43 1.77002C38.85 1.52002 44.5 1.56002 50.69 1.89002C56.47 2.20002 62.34 2.76002 68.13 3.55002C73.95 4.35002 79.21 5.30002 84.21 6.47002C89.35 7.66002 93.42 8.88002 97.02 10.3C99.92 11.44 102.7 12.64 104.85 14.7C105.36 15.19 106.07 15.96 106.34 16.95C106.44 17.29 106.48 17.65 106.48 17.99C106.48 18.16 106.46 18.32 106.44 18.49C106.42 18.61 106.4 18.68 106.37 18.75L106.3 18.88C106.27 18.93 106.17 19.09 106.1 19.19C105.89 19.47 105.63 19.75 105.32 20.03C103.81 21.37 101.91 22.13 100.08 22.74C97.88 23.48 95.5 24.04 92.37 24.57C87.38 25.41 81.98 25.91 74.87 26.19C71.22 26.34 67.34 26.4 63.35 26.38H62.95C62.39 26.38 62.23 27.76 62.23 27.77V28.02H62.48C63.97 28.03 65.47 28.03 66.96 28.02C72.89 27.96 78.19 27.73 83.16 27.29C88.62 26.81 94.41 26.19 99.92 24.32C101.81 23.68 103.78 22.89 105.34 21.46C106.43 20.46 107.56 18.7 107.47 16.75C107.34 13.9 104.53 12.18 103.17 11.35L103.2 11.37Z';
    return path;
}




document.addEventListener('DOMContentLoaded', () => {
    // const _svgCirclePath = 'M69.4998 26.5C89.4998 26 113.533 25.5 117.5 17C121.466 8.5 77.4998 1 45.4998 1C13.4998 1 1.99977 7 1.49977 15.5C0.999767 24 11.4998 31.5 49.4998 31C79.8998 30.6 95.4999 28.5 99.5 27.5';
    // const _svgCirclePath = 'm10.33,8.86c2.06,4.57,41.8,14.83,64.28,6.31C96.21,6.98,63.38.38,36.13,2.21,8.25,4.08-8.04,11.54,5.19,17.53c11.82,5.36,75.45,5.18,70.25-7.73C69.49-4.99-4.41-.32,2.35,11.32c5.59,9.61,47.23,7,49.28,5.05';
    const _svgCirclePath = 'm14.77,12.62c2.99,6.65,60.76,21.56,93.45,9.17C139.62,9.9,91.89.3,52.27,2.96,11.74,5.67-11.94,16.52,7.29,25.24c17.18,7.79,109.68,7.54,102.13-11.24C100.77-7.5-6.66-.71,3.17,16.2c8.12,13.98,68.67,10.18,71.64,7.34';
    let circleHighlight = new FumCircleHighlight(
        'circle-highlight',
        '--fum-circle-hightlight-',
        false,
        false,
        _svgCirclePath
    );
    circleHighlight
    .sx({
        thickness: '1',
        color: 'var(--highlight)'
        // color: '#b0b053' // I just put this color darker for better visibility during testing
    })
    .init(true);
});